// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html.ticket-native-document {
  overflow-y: scroll;
  overscroll-behavior: none;
  scroll-behavior: auto !important;
  overflow-anchor: none;
}

body.ticket-native-document {
  margin: 0;
  height: var(--ticket-document-height);
  min-height: var(--ticket-document-height);
  overscroll-behavior: none;
}

body.ticket-native-document .ticket-chat-page {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
}

.ticket-chat-page .ticket-chat-messages {
  scroll-behavior: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  overflow-anchor: none;
}

.ticket-chat-page .ticket-chat-header,
.ticket-chat-page .ticket-chat-rating {
  flex-shrink: 0;
}

.ticket-chat-new-messages {
  align-self: center;
  flex-shrink: 0;
  margin: 4px 8px 8px;
  border: 0;
  border-radius: 16px;
  padding: 8px 16px;
  color: #fff;
  background: #e72f44;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/pages/shared/ticketViewport.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,yBAAA;EACA,gCAAA;EACA,qBAAA;AACF;;AAEA;EACE,SAAA;EACA,qCAAA;EACA,yCAAA;EACA,yBAAA;AACF;;AAEA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;AACF;;AAEA;EACE,qBAAA;EACA,4BAAA;EACA,iCAAA;EACA,qBAAA;AACF;;AAEA;;EAEE,cAAA;AACF;;AAEA;EACE,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;AACF","sourcesContent":["html.ticket-native-document {\n  overflow-y: scroll;\n  overscroll-behavior: none;\n  scroll-behavior: auto !important;\n  overflow-anchor: none;\n}\n\nbody.ticket-native-document {\n  margin: 0;\n  height: var(--ticket-document-height);\n  min-height: var(--ticket-document-height);\n  overscroll-behavior: none;\n}\n\nbody.ticket-native-document .ticket-chat-page {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  width: 100%;\n}\n\n.ticket-chat-page .ticket-chat-messages {\n  scroll-behavior: auto;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n  overflow-anchor: none;\n}\n\n.ticket-chat-page .ticket-chat-header,\n.ticket-chat-page .ticket-chat-rating {\n  flex-shrink: 0;\n}\n\n.ticket-chat-new-messages {\n  align-self: center;\n  flex-shrink: 0;\n  margin: 4px 8px 8px;\n  border: 0;\n  border-radius: 16px;\n  padding: 8px 16px;\n  color: #fff;\n  background: #e72f44;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
